import { FC } from "react";
import SmartSearchDatePickerAndActionsLayout from "../../../components/Layouts/smart-search-date-picker-and-actions-layout";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { getDrawerActivityReport } from "../../../services/reports";
import { DateFormatEnum } from "../../../enums/dateFormatEnum";
import { SearchStatusEnum } from "../../../enums/searchStatusEnum";

const ReportDrawerActivity: FC = () => {
  return (
    <SmartSearchDatePickerAndActionsLayout
      searchBy={[SearchOptionEnum.LOCATION]}
      validOnEmpty={false}
      searchStatus={[SearchStatusEnum.ACTIVE]}
      actions={[ActionButtonEnum.REFRESH, ActionButtonEnum.SAVE_PDF, ActionButtonEnum.SAVE_CSV]}
      onRefresh={(output, params, date) =>
        getDrawerActivityReport({
          date: date.format(DateFormatEnum.MONTH_DAY_YEAR),
          [`${params.type}Id`]: params.id,
          output
        })
      }
    />
  );
};

export default ReportDrawerActivity;
